<template>
  <div>
    <v-row>
      <v-col>
        <CustomerRolesComponent :categories="categories" :responsibilities="responsibilities" />
      </v-col>
    </v-row>
    
    <v-row>
      <v-col>
        <RoleCategoriesComponent @loaded="onCategoriesLoaded" />
      </v-col>
    </v-row>
    
    <v-row>
      <v-col>
        <ResponsibilitiesComponent @loaded="onResponsibilitiesLoaded" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CustomerRolesComponent from '@/components/customer/CustomerRolesComponent.vue';
import RoleCategoriesComponent from '@/components/customer/RoleCategoriesComponent.vue';
import ResponsibilitiesComponent from '@/components/customer/ResponsibilitiesComponent.vue';

export default {
  name: 'CustomerRoles',
  components: {
    CustomerRolesComponent,
    RoleCategoriesComponent,
    ResponsibilitiesComponent
  },
  props: ['customer'],
  data() {
    return {
      categories: [],
      responsibilities: []
    }
  },
  methods: {
    onCategoriesLoaded: function(categories) {
      this.categories = categories;
    },
    onResponsibilitiesLoaded: function(responsibilities) {
      this.responsibilities = responsibilities;
    }
  }
}
</script>